import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateStr) {
  if (!dateStr) return '-';
  try {
    return new Date(dateStr).toLocaleDateString('tr-TR', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  } catch {
    return dateStr;
  }
}

export function statusBadgeClass(status) {
  const map = {
    'active': 'badge-aktif',
    'aktif': 'badge-aktif',
    'draft': 'badge-taslak',
    'taslak': 'badge-taslak',
    'paused': 'badge-duraklatildi',
    'duraklatildi': 'badge-duraklatildi',
    'published': 'badge-aktif',
    'completed': 'badge-aktif',
    'running': 'badge-duraklatildi',
    'pending': 'badge-taslak',
    'failed': 'badge-hata',
  };
  return map[status] || 'badge-taslak';
}

export function statusLabel(status) {
  const map = {
    'active': 'Aktif',
    'draft': 'Taslak',
    'paused': 'Duraklatildi',
    'published': 'Yayinda',
    'completed': 'Tamamlandi',
    'running': 'Uretiliyor',
    'pending': 'Sirada',
    'failed': 'Hata',
  };
  return map[status] || status;
}
